module.exports = __webpack_public_path__ + "img/certificate.0d86d14b.jpg";